import { Redirect, useParams } from "wouter";
import { createPath, UniversalRoutes } from "@/routers/routes";

export const JoinGroup = () => {
  const { groupId } = useParams<{ groupId: string }>();

  // Redirect to the group detail page
  const groupDetailPath = createPath({
    path: UniversalRoutes.GROUPS.DETAIL,
    params: { groupId: groupId },
  });

  return <Redirect to={groupDetailPath} />;
};
